import * as React from "react"
import styled from 'styled-components';
import { Container } from "react-bootstrap";
import Button from 'react-bootstrap/Button';
import { CgEditBlackPoint } from "@react-icons/all-files/cg/CgEditBlackPoint";
import { useConfig } from "../hooks/use-config"

const StyledContainer = styled(Container)`

.top-main {
  width: 85%;
  margin: auto;
  text-align: center;
  /* background-color: #ffa90033; */
  border-radius: 10px;
  padding: 10px;
  border: 1px solid #80808042;
}

.main {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  align-items: center;
  flex-direction: column;
  gap: 15px;
  color: #000000b0;
  font-weight: bold !important;
}

.lists {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
   /* display: table-cell; */
  vertical-align: middle; 
  font-weight: 500;
  line-height: normal;
  list-style-type: none; 
  color: rgb(61 58 58 / 81%);
  padding-top: 10px;
  margin: 0px;
  font-weight: bold !important;
}

.free-class{
  margin-top: 100px;
  margin-bottom: 100px;
}

ul > li {
  padding-right: 15px;
  padding-bottom: 15px;
}

.map {
  color: #ffa700;
}

.free-credit-btn:hover {
  background-color: #ffb426;
  border-color: #ffb426;
}

@media (max-width: 991px) {
  .lists {
    text-align: left;
    justify-content: left;
  }

  @media (max-width: 768px) {
    .top-main {
      width: 100%;
      padding: 0px;
      border: 0px;
    }
  }
}
`

const CreateFreeAccount = () => {
  const { clearout: clearoutConfig } = useConfig()

  return (
    <StyledContainer>
      <div className="top-main">
        <div className="main pt-2">
          <h3 className="fw-bolder">Create a Free Account With 100 Credits</h3>
          <a href={clearoutConfig.app.registerUrl} target="_blank" rel="noreferrer">
            <Button variant="primary" className="free-credit-btn fw-bold p-2 px-4">Get Clearout Now</Button>
          </a>
          <ul className="lists">
            <li><CgEditBlackPoint className="map" /> Credits Never Expire</li>
            <li><CgEditBlackPoint className="map" /> 24/7 Support With Experts</li>
            <li><CgEditBlackPoint className="map" /> Fully GDPR Compliant</li>
            <li><CgEditBlackPoint className="map" /> ISO & SOC 2 Type II Certified</li>
          </ul>
        </div>
      </div>

    </StyledContainer>
  )
}

export default CreateFreeAccount;